<mat-card class="h-100" [ngClass]="{ 'home-video-card': isHomePage == 'landing' }">
  <div class="video-wrapper">
    <div class="wrap">
      <div class="player" (mouseenter)="onHover(true)" (mouseleave)="onHover(false)" [id]="'player-' + index">
        <div class="hover-overlay" [ngClass]="{ 'active': hovered }"></div>
        <!-- Render iframe for YouTube/Vimeo embeds -->
        <ng-container *ngIf="isIframeVideo(); else nativeVideo">
          <iframe [src]="video.autoplayLink || (video.videoUrl | safeUrl)"
            allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="{{ video.title }}"
            (load)="onIframeLoad()"
            loading="lazy"
            style="border:none; position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100%; max-width: 100%;"></iframe>
        </ng-container>

         <!-- {{video.VTT_File_Link}} -->

        <ng-template #nativeVideo>
       <!-- render native <video> only for non-embed sources -->
          <!-- Show thumbnail (first frame) until play -->
          <ng-container *ngIf="!isIframeVideo() && video">
            <!-- Show static thumbnail until first video frame is ready (prevents 1s blank screen) -->
            <ng-container *ngIf="!video.is_playing || !(video.__isVideoReady)">
              <button
                type="button"
                [id]="'video-thumb-btn-' + index"
                (click)="!video.is_playing && playVideo(video)"
                [style.cursor]="!video.is_playing ? 'pointer' : 'default'"
                [style.zIndex]="!video.is_playing ? 2 : 1"
                [disabled]="video.is_playing"
                style="border:none; padding:0; background: transparent; position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100%; width: 100%;"
                [attr.aria-label]="video.title"
              >
                <img
                  [id]="'video-thumb-' + index"
                  [src]="getThumbnailSrc(video)"
                  title="{{ video.title }}"
                  (load)="onThumbnailLoad()"
                  loading="lazy"
                  decoding="async"
                  style="border:none; height: 100%; width: 100%; max-width: 100%; object-fit: cover;"
                  (error)="onThumbnailError(video)"
                  alt="{{ video.title }} thumbnail"
                />
              </button>
              <!-- Center Play Overlay (only before play) -->
              <div class="center-play" [id]="'centerOverlay-' + index" *ngIf="!video.is_playing" style="z-index: 3;">
                <button [id]="'centerPlayBtn-' + index" aria-label="Play" (click)="!video.is_playing && playVideo(video)">
                  <img class="stkh-table-filter-img" src="../assets/images/videooptions/play.png" alt="Play">
                </button>
              </div>
            </ng-container>
            <!-- Show main video and controls only when playing -->
            <ng-container *ngIf="video.is_playing">
              <video
                [id]="'video-' + index"
                [src]="video.videoUrl"
                crossorigin="anonymous"
                [attr.poster]="getThumbnailSrc(video)"
                preload="auto"
                title="{{ video.title }}"
                style="border:none; position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100%; max-width: 100%;"
                (loadeddata)="onVideoReady(video)"
                (canplay)="onVideoReady(video)"
                (playing)="onVideoReady(video)"
                (waiting)="onVideoWaiting(video)"
              >
                <track id="englishCaption" label="English" kind="subtitles" srclang="en"
                  [src]="video.vttBlobUrl" default />
                Your browser does not support HTML5 video.
              </video>
              <!-- Controls: only show when playing -->
              <div class="controls" [id]="'controls-'+ index" [class.hidden]="">
                <div class="progress-container" [id]="'progressContainer-'+ index" aria-label="Seek">
                  <div class="progress" [id]="'progress-'+ index"></div>
                </div>
                <div class="buttons">
                  <div class="left-controls">
                    <button class="ctrl playPauseBtn" [id]="'playPause-'+ index" aria-label="Play">
                      <img [id]="'playPauseImg-'+ index" class="stkh-table-filter-img" src="../assets/images/videooptions/play.png" alt="Play">
                    </button>
                    <button class="ctrl rewind-btn" [id]="'rewind-'+ index" aria-label="Rewind 10 seconds">
                      <img class="stkh-table-filter-img" src="../assets/images/videooptions/playwackword.png" alt="Rewind">
                    </button>
                    <button class="ctrl forward-btn" [id]="'forward-'+ index" aria-label="Forward 10 seconds">
                      <img class="stkh-table-filter-img" src="../assets/images/videooptions/playforward.png" alt="Forward">
                    </button>
                    <!-- Unified volume control moved to left next to jump controls -->
                    <div class="volume-control">
                      <button class="ctrl" [id]="'volumeBtn-'+ index" aria-label="Volume">
                      </button>
                      <div class="volume-panel hidden" [id]="'volumePanel-'+ index" aria-hidden="true">
                        <input [id]="'volumeRange-'+ index" type="range" min="0" max="1" step="0.01" [value]="0.5" />
                      </div>
                    </div>
                    <span class="time" [id]="'time-'+ index">0:00 / 0:00</span>
                  </div>
                  <div class="right-controls">
                    <!-- Keep only captions and speed on the right (Stream-like) -->
                    <!-- Speed control: button opens panel with selectable speeds -->
                    <div class="speed-control">
                      <button class="ctrl" [id]="'speedBtn-'+ index" aria-label="Playback Speed">1x</button>
                      <div class="speed-panel hidden" [id]="'speedPanel-'+ index" aria-hidden="true">
                        <button class="speed-option" data-speed="0.5">0.5x</button>
                        <button class="speed-option" data-speed="0.75">0.75x</button>
                        <button class="speed-option" data-speed="1">1x</button>
                        <button class="speed-option" data-speed="1.25">1.25x</button>
                        <button class="speed-option" data-speed="1.5">1.5x</button>
                        <button class="speed-option" data-speed="2">2x</button>
                      </div>
                    </div>
                    <button class="ctrl cc-btn" [id]="'captions-'+ index" aria-label="Captions">
                      <img class="stkh-table-filter-img" src="../assets/images/videooptions/cc.png" alt="Captions">
                      <!-- CC -->
                    </button>
                    <button class="ctrl fullscreen-btn me-1" [id]="'fullscreen-'+ index" (click)="toggleFullscreen(index)" aria-label="Fullscreen">
                      <img class="stkh-table-filter-img" src="../assets/images/videooptions/expand.png" alt="Fullscreen">
                      <!-- ⛶ -->
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
  <mat-card-content *ngIf="isHomePage != 'singleVideo'">
    <ng-container *ngIf="isHomePage == 'landing'">
      <p class="pt-2 m-0 home-video-content">
        <!--add router link to single video-->
        <a [routerLink]="['/video-library', video.id]" style="text-decoration:none;">{{ video?.title }}</a>
      </p>
    </ng-container>
    <ng-container *ngIf="isHomePage == 'library'">
      <h6 class="mt-2">
        <a [routerLink]="['/video-library', video.id]" style="text-decoration:none;">{{ video.title }}</a>
      </h6>
      <p class="mb-1 text-muted">{{ video.upload_date | date: 'MMMM d, y' }}</p>
      <p class="mb-0 text-muted"><span style="font-weight: bold;">Category:</span> {{ video.category }}</p>
      <p class="mb-0 text-muted"><span style="font-weight: bold;">Duration:</span> {{ video.duration }}</p>
    </ng-container>
  </mat-card-content>
</mat-card>